const mixFilter = {
    data() {
        return {
            api_get_product: null,
            product_filter_res: {},
            product_filter_top: 0,
            product_filter_fixed: false,
        }
    },
    computed: {
        filter_onoff() {
            let { items, config } = this.product_filter_res;
            if (config && config.pc_show_type == "hover_left") {
                this.product_filter_fixed = true;
                window.addEventListener(
                    "scroll",
                    this.debounce(() => {
                        this.product_filter_top = this.accumulator_height([
                            ".site-header",
                            ".section-header-notice",
                            ".section-header",
                        ]);
                    }, 200),
                    true
                );
            }
            return items && items.length;
        },
    },
    beforeMount() {
        if (this.product_filter) {
            this.product_filter_res = this.product_filter;
        }
    },
    mounted() {
        this.api_get_product = this.debounce(async (payload) => {
            let pathname = window.location.pathname.split('/');
            let type = pathname[1];
            let search = this.setObjSeach(Object.assign({ type, page_size: !isNaN(this.page_size) ? this.page_size : 12 }, payload, type === 'collections' ? { slug: pathname[2] } : {}));
            window.history.replaceState({}, "", search);
            this.$axios.get(`/api/store/products${search}`).then(res => {
                if (res.data && Object.values(res.data).length) this.products_page = { ...res.data, ...res.data.links, ...res.data.meta };
                else this.products_page = {};
            }).catch(err => {
                this.products_page = {};
            })
            if (this.filter_onoff) {
                this.$axios.get(`/api/store/product_filters${search}`).then(res => {
                    if (res.data) this.product_filter_res = res.data;
                    else this.product_filter_res = {};
                }).catch(err => {
                    this.product_filter_res = {};
                })
            }
        }, 200);
    }
}
export default mixFilter;
